module.exports = __webpack_public_path__ + "static/media/sensenet_white.3a0b3368.png";